import axios from 'axios';
import http from '../../../http-common';

export default function requestLoadCasetasLiq(viajeId) {
    return http.get(`/casetas/liq/${viajeId}`);
}
